import { defaultTListForm } from "../models/TForm";
import { TListing3ReadOnlyFormList } from "../models/TFormModels";

export class C {
    searchInput: string = "";
    searchResponseListings: TListing3ReadOnlyFormList = defaultTListForm({}, {});
}
